import { render, staticRenderFns } from "./TagCarbonTable.vue?vue&type=template&id=126b43bc&"
import script from "./TagCarbonTable.vue?vue&type=script&lang=ts&"
export * from "./TagCarbonTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports